import React, {useEffect} from 'react'
import {Modal} from 'react-bootstrap-v5'
import {useDispatch} from 'react-redux'
import {Redirect, Switch} from 'react-router-dom'
import PopUp from './components/PopUp'
import useModal from './hooks/useModal'

export function Logout() {
  const dispatch = useDispatch()
  useEffect(() => {
    localStorage.clear()
    document.location.reload()
  }, [dispatch])
  const {stateModal, toggleModal, offModal} = useModal()

  return (
    <Switch>
      <Redirect to='/auth/login' />
    </Switch>
  )
}
